import { requestCreator } from "../actions/VisitApi";

export type MegaphoneLocation = "companies_show_values_section" | "company_values_lp";

export interface MegaphoneApiData {
  name: string;
  analysis_id: number;
  data: any;
}

export type LoadMegaphonesResponse = { [key in MegaphoneLocation]?: MegaphoneApiData | null };

export const requestToLoadMegaphones = requestCreator<MegaphoneLocation[], LoadMegaphonesResponse, Error>(params => ({
  path: "/api/internal/megaphones",
  query: {
    locations: params,
  },
}));

export const requestToOpenMegaphone = requestCreator<{ analysisId: number }, null, Error>(params => ({
  path: `/api/internal/megaphones/${params.analysisId}/open`,
  method: "POST",
}));

export const requestToCloseMegaphone = requestCreator<{ analysisId: number }, null, Error>(params => ({
  path: `/api/internal/megaphones/${params.analysisId}/close`,
  method: "POST",
}));

export const requestToClickMegaphone = requestCreator<{ analysisId: number }, null, Error>(params => ({
  path: `/api/internal/megaphones/${params.analysisId}/click`,
  method: "POST",
}));



// WEBPACK FOOTER //
// ./frontend/src/common/api/megaphones.ts